import { useSearchParams } from 'react-router';
import { useSnapshot } from '../lib/snapshot-context';
import { Hero } from '../components/Hero/Hero';
import { MasonryGrid } from '../components/MasonryGrid/MasonryGrid';
import { Lightbox } from '../components/Lightbox/Lightbox';
import { readLightboxState } from '../lib/lightbox-state';
import { useMediaQuery } from '../hooks/useMediaQuery';
import styles from './PortfolioPage.module.css';

export function PortfolioPage() {
  const { settings, items } = useSnapshot();
  const [params] = useSearchParams();
  const lightbox = readLightboxState(params, items);
  const gap = useMediaQuery('(min-width: 1024px)') ? 24 : 16;

  return (
    <>
      <title>{`${settings.heroTitle} — ${settings.heroSubtitle}`}</title>
      <Hero
        title={settings.heroTitle}
        subtitle={settings.heroSubtitle}
        video={settings.heroVideo}
        poster={settings.heroPoster}
      />
      <main id="work" className={styles.sheet}>
        <h2 className="visually-hidden">Work</h2>
        <MasonryGrid items={items} gap={gap} />
      </main>
      {lightbox && <Lightbox key={lightbox.item.id} item={lightbox.item} index={lightbox.index} />}
    </>
  );
}
